export default function TextCell(props) {
  const { value } = props
  return <span>{value}</span>
}
